// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_wrk_ctx_proc = require("./MM_wrk_ctx_proc.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_asrt_syntax_tree = require("../mm-utils/MM_asrt_syntax_tree.res.js");

var procName = "MM_wrk_syntax_tree";

function reqToStr(req) {
  return "BuildSyntaxTreesForAllAsrts";
}

function respToStr(resp) {
  if (resp.TAG === "OnProgress") {
    return "OnProgress(pct=" + String(resp._0) + ")";
  } else {
    return "Result";
  }
}

function buildSyntaxTreesForAllAssertions(settingsV, preCtxVer, preCtx, onProgress) {
  return new Promise((function (resolve, param) {
                MM_wrk_ctx_proc.beginWorkerInteractionUsingCtx(settingsV.ver, settingsV.val, preCtxVer, preCtx, "", "", procName, "BuildSyntaxTreesForAllAsrts", (function (resp, param, endWorkerInteraction) {
                        if (resp.TAG === "OnProgress") {
                          return onProgress(resp._0);
                        }
                        endWorkerInteraction();
                        resolve(resp._0);
                      }), false);
              }));
}

function doBuildSyntaxTreesForAllAssertions(ctx, frms, parenCnt, allowedFrmsInSyntax, syntaxTypes, onProgress) {
  var ctx$1 = MM_context.createContext(Caml_option.some(ctx), undefined);
  var typToLocVar = Belt_HashMapInt.make(4);
  var tmpCtxHyps = Belt_HashMapString.make(4);
  var createNewVar = function (typ) {
    var match = MM_context.generateNewLabels(ctx$1, "locVar", 1, undefined, undefined);
    if (match.length !== 1) {
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "MM_wrk_syntax_tree.res",
              80,
              12
            ],
            Error: new Error()
          };
    }
    var label = match[0];
    var match$1 = MM_context.generateNewVarNames(ctx$1, [typ], undefined, undefined);
    if (match$1.length !== 1) {
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "MM_wrk_syntax_tree.res",
              82,
              12
            ],
            Error: new Error()
          };
    }
    var varName = match$1[0];
    MM_context.applySingleStmt(ctx$1, {
          TAG: "Var",
          symbols: [varName]
        }, undefined, undefined, undefined, undefined);
    MM_context.applySingleStmt(ctx$1, {
          TAG: "Floating",
          label: label,
          expr: [
            MM_context.ctxIntToSymExn(ctx$1, typ),
            varName
          ]
        }, undefined, undefined, undefined, undefined);
    Belt_HashMapString.set(tmpCtxHyps, label, Core__Option.getExn(MM_context.getHypothesis(ctx$1, label), "tmpCtxHyps"));
    return MM_context.ctxSymToIntExn(ctx$1, varName);
  };
  var asrtExprsWithCtxVars = Belt_HashMapString.make(1000);
  MM_context.forEachFrame(ctx$1, (function (frame) {
          Belt_HashMapString.set(asrtExprsWithCtxVars, frame.label, frame.asrt.map(function (i) {
                    if (i < 0) {
                      return i;
                    } else {
                      var typ = frame.varTypes[i];
                      var locVar = Belt_HashMapInt.get(typToLocVar, typ);
                      if (locVar !== undefined) {
                        return locVar;
                      }
                      var newVar = createNewVar(typ);
                      Belt_HashMapInt.set(typToLocVar, typ, newVar);
                      return newVar;
                    }
                  }));
        }));
  var exprsToSyntaxProve = Expln_utils_common.sortInPlaceWith(Belt_HashMapString.valuesToArray(asrtExprsWithCtxVars), Expln_utils_common.cmpRev(Expln_utils_common.comparatorByInt(function (__x) {
                  return __x.length;
                }))).map(function (expr) {
        return expr.slice(1);
      });
  var proofTree = MM_provers.proveSyntaxTypes(undefined, Caml_option.some(ctx$1), Caml_option.some(frms), allowedFrmsInSyntax, Caml_option.some(parenCnt), exprsToSyntaxProve, syntaxTypes, onProgress);
  var makeCtxIntToAsrtInt = function (asrtExpr) {
    var curIdx = {
      contents: -1
    };
    var maxIdx = asrtExpr.length - 1 | 0;
    return function (ctxInt) {
      if (ctxInt < 0) {
        return ctxInt;
      }
      curIdx.contents = curIdx.contents + 1 | 0;
      while(curIdx.contents <= maxIdx && asrtExpr[curIdx.contents] < 0) {
        curIdx.contents = curIdx.contents + 1 | 0;
      };
      if (maxIdx >= curIdx.contents) {
        return asrtExpr[curIdx.contents];
      }
      var errMsg = "makeCtxIntToAsrtInt: asrtExpr=" + Expln_utils_common.stringify(asrtExpr) + (", ctxInt=" + ctxInt.toString());
      console.error(errMsg);
      return Js_exn.raiseError(errMsg);
    };
  };
  var result = [];
  MM_context.forEachFrame(ctx$1, (function (frame) {
          var asrtExprWithCtxVars = Belt_HashMapString.get(asrtExprsWithCtxVars, frame.label);
          if (asrtExprWithCtxVars !== undefined) {
            var proofNode = MM_proof_tree.ptGetSyntaxProof(proofTree, asrtExprWithCtxVars.slice(1));
            if (proofNode !== undefined) {
              var msg = MM_asrt_syntax_tree.buildSyntaxTree(Caml_option.valFromOption(proofNode), makeCtxIntToAsrtInt(frame.asrt), (function (asrtInt) {
                      return MM_context.frmIntToSymExn(ctx$1, frame, asrtInt);
                    }), (function (label, asrtVar) {
                      return Core__Option.flatMap(Belt_HashMapString.get(tmpCtxHyps, label), (function (ctxHyp) {
                                    var typ = ctxHyp.typ;
                                    var asrtHyp = frame.hyps[frame.varHyps[asrtVar]];
                                    if (asrtHyp.typ === typ) {
                                      return asrtHyp.label;
                                    }
                                    
                                  }));
                    }));
              if (msg.TAG === "Ok") {
                result.push([
                      frame.label,
                      msg._0
                    ]);
              } else {
                console.error("Could not build an asrt syntax tree: " + msg._0);
              }
            }
            
          }
          
        }));
  return result;
}

function processOnWorkerSide(req, sendToClient) {
  sendToClient({
        TAG: "Result",
        _0: doBuildSyntaxTreesForAllAssertions(MM_wrk_ctx_proc.getWrkCtxExn(), MM_wrk_ctx_proc.getWrkFrmsExn(), MM_wrk_ctx_proc.getWrkParenCntExn(), MM_wrk_ctx_proc.getSettingsExn().allowedFrms.inSyntax, MM_wrk_ctx_proc.getSyntaxTypesExn(), (function (pct) {
                sendToClient({
                      TAG: "OnProgress",
                      _0: pct
                    });
              }))
      });
}

exports.procName = procName;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
exports.buildSyntaxTreesForAllAssertions = buildSyntaxTreesForAllAssertions;
exports.doBuildSyntaxTreesForAllAssertions = doBuildSyntaxTreesForAllAssertions;
exports.processOnWorkerSide = processOnWorkerSide;
/* MM_context Not a pure module */
